module.exports = __webpack_public_path__ + "img/DNADamage-GBM_10X_TPCP.17c849e5.png";